import {
  DropDownFilter,
  FilterOption,
} from '@design-system/components/dropDown/dropDownFilter';
import { SearchInput } from '@design-system/components/searchinput';

import {
  ProgramsFilters as ProgramsFiltersState,
  ProgramsVM,
} from '../../view-model/programs.viewModel.types';

import * as styles from './ProgramsFilters.css';

type ProgramsFiltersProps = {
  state: Pick<ProgramsVM['state'], 'searchText' | 'filters'>;
  dispatch: ProgramsVM['dispatch'];
};

type StatusFilterValue = Exclude<ProgramsFiltersState['status'], 'all'>;
type OffersFilterValue = Exclude<ProgramsFiltersState['offers'], 'all'>;
type ConsumerTabFilterValue = Exclude<
  ProgramsFiltersState['consumerTab'],
  'all'
>;

const STATUS_OPTIONS: Array<FilterOption<StatusFilterValue>> = [
  { label: 'Draft', value: 'draft' },
  { label: 'Ready', value: 'ready' },
  { label: 'Published', value: 'published' },
  { label: 'Archived', value: 'archived' },
];

const OFFERS_OPTIONS: Array<FilterOption<OffersFilterValue>> = [
  { label: 'Subscription', value: 'subscription' },
  { label: 'OTP', value: 'otp' },
  { label: 'None', value: 'none' },
];

const CONSUMER_TAB_OPTIONS: Array<FilterOption<ConsumerTabFilterValue>> = [
  { label: 'Collections', value: 'collections' },
  { label: 'Purchases', value: 'purchases' },
  { label: 'None', value: 'none' },
];

const toDropdownValue = <T extends string>(value: T | 'all'): T | undefined => {
  if (value === 'all') return undefined;
  return value;
};

export const ProgramsFilters = ({ state, dispatch }: ProgramsFiltersProps) => {
  return (
    <div className={styles.filtersContainer} data-testid="programs-filters">
      <div className={styles.searchInputContainer}>
        <SearchInput
          placeholder="Search by name"
          value={state.searchText}
          onChange={(event) => dispatch('Search', event.target.value)}
          onClear={() => dispatch('Search', '')}
        />
      </div>

      <DropDownFilter
        label="Status"
        options={STATUS_OPTIONS}
        value={toDropdownValue(state.filters.status)}
        onSelect={(value) => dispatch('SetFilter', { status: value ?? 'all' })}
      />

      <DropDownFilter
        label="Offers"
        options={OFFERS_OPTIONS}
        value={toDropdownValue(state.filters.offers)}
        onSelect={(value) => dispatch('SetFilter', { offers: value ?? 'all' })}
      />

      <DropDownFilter
        label="Consumer tab"
        options={CONSUMER_TAB_OPTIONS}
        value={toDropdownValue(state.filters.consumerTab)}
        onSelect={(value) =>
          dispatch('SetFilter', { consumerTab: value ?? 'all' })
        }
      />
    </div>
  );
};
